// City / service-area landing page data — SEO focused (Washington only, 2-hr radius of Spokane)
export const AREAS = {
  "spokane-wa": {
    slug: "spokane-wa",
    city: "Spokane",
    state: "WA",
    display: "Spokane, WA",
    distance: "Home base",
    driveTime: "0 minutes — local",
    neighborhoods: ["South Hill", "North Side", "Indian Trail", "Five Mile Prairie", "Hillyard", "West Plains", "Downtown", "Logan"],
    intro:
      "Castellon Septic Services is headquartered right here in Spokane. We know the soil, the neighborhoods, and the rural pockets on the edge of the city where septic systems are still the norm. From the South Hill to Five Mile Prairie, we are the local crew that shows up on time.",
    keyword: "septic pumping Spokane WA",
  },
  "spokane-valley-wa": {
    slug: "spokane-valley-wa",
    city: "Spokane Valley",
    state: "WA",
    display: "Spokane Valley, WA",
    distance: "15 min from HQ",
    driveTime: "15–25 minutes",
    neighborhoods: ["Greenacres", "Veradale", "Otis Orchards", "Liberty Lake", "Millwood", "Trentwood"],
    intro:
      "Spokane Valley homes and businesses east of the city rely on septic systems more than the urban core. We service residential tanks, commercial properties, and restaurants from Liberty Lake to Millwood — same standards, same 1,800-gallon truck, same crew.",
    keyword: "septic pumping Spokane Valley WA",
  },
  "airway-heights-wa": {
    slug: "airway-heights-wa",
    city: "Airway Heights",
    state: "WA",
    display: "Airway Heights, WA",
    distance: "15 min W of Spokane",
    driveTime: "15–25 minutes",
    neighborhoods: ["West Plains", "Craig Road corridor", "Hayford", "Geiger area"],
    intro:
      "Airway Heights is one of the fastest-growing cities on the West Plains. Between the casino, the hotels, the new residential subdivisions, and the commercial strip along Highway 2, we service everything from single-family septic tanks to large-volume grease traps. Same 1,800-gallon truck, same predictable pricing.",
    keyword: "septic pumping Airway Heights WA",
  },
  "cheney-wa": {
    slug: "cheney-wa",
    city: "Cheney",
    state: "WA",
    display: "Cheney, WA",
    distance: "20 min SW of Spokane",
    driveTime: "25–35 minutes",
    neighborhoods: ["EWU area", "Four Lakes", "Tyler", "Medical Lake"],
    intro:
      "Cheney has a lot of rural and farm properties on septic systems, plus a busy student-housing market around Eastern Washington University. Castellon handles residential, multi-unit, and grease trap service for the area on a predictable schedule.",
    keyword: "septic pumping Cheney WA",
  },
  "deer-park-wa": {
    slug: "deer-park-wa",
    city: "Deer Park",
    state: "WA",
    display: "Deer Park, WA",
    distance: "30 min N of Spokane",
    driveTime: "30–45 minutes",
    neighborhoods: ["Clayton", "Loon Lake area", "Chattaroy", "Wild Rose Prairie"],
    intro:
      "Deer Park and the surrounding rural properties almost universally run on septic. We bring a 1,800-gallon vacuum truck out there in a single trip — competitors often need two visits and charge for both. Our regulars in Deer Park keep us on speed dial.",
    keyword: "septic pumping Deer Park WA",
  },
  "chewelah-wa": {
    slug: "chewelah-wa",
    city: "Chewelah",
    state: "WA",
    display: "Chewelah, WA",
    distance: "55 min N of Spokane",
    driveTime: "50–65 minutes",
    neighborhoods: ["49° North area", "Valley", "Blue Creek", "Addy"],
    intro:
      "Chewelah, up US-395 in Stevens County, is almost entirely septic country — rural homes, orchards, small farms, and cabins around 49° North. We run regular routes up the valley so a Chewelah call rarely means a wasted trip. Book online and we'll pair you with the next northbound run.",
    keyword: "septic pumping Chewelah WA",
  },
  "colville-wa": {
    slug: "colville-wa",
    city: "Colville",
    state: "WA",
    display: "Colville, WA",
    distance: "1 hr 15 min N of Spokane",
    driveTime: "1h 10m – 1h 25m",
    neighborhoods: ["Downtown Colville", "Arden", "Kettle Falls corridor", "Rice"],
    intro:
      "Colville is the biggest town in Stevens County and everything outside the city core is on septic. Most local operators run small trucks and hard-to-pin schedules. We come up with a 1,800-gallon vacuum truck, do the tank in one trip, and keep our appointments. Grease trap contracts for Colville restaurants available.",
    keyword: "septic pumping Colville WA",
  },
  "newport-wa": {
    slug: "newport-wa",
    city: "Newport",
    state: "WA",
    display: "Newport, WA",
    distance: "50 min NE of Spokane",
    driveTime: "45–60 minutes",
    neighborhoods: ["Diamond Lake", "Sacheen Lake", "Usk", "Cusick"],
    intro:
      "Newport sits on the Washington side of the Pend Oreille River and the whole area — from Diamond Lake to Usk — runs on septic. Vacation cabins, full-time rural homes, and lakeside properties all need routine pumping. We schedule Newport runs weekly, so you're never waiting a month for service.",
    keyword: "septic pumping Newport WA",
  },
  "pullman-wa": {
    slug: "pullman-wa",
    city: "Pullman",
    state: "WA",
    display: "Pullman, WA",
    distance: "1 hr 20 min S of Spokane",
    driveTime: "1h 15m – 1h 30m",
    neighborhoods: ["WSU campus area", "College Hill", "Military Hill", "Pioneer Hill", "Palouse"],
    intro:
      "Pullman is home to Washington State University — which means a dense mix of student housing, restaurants, and rural properties on the Palouse. We handle grease trap contracts for downtown restaurants and septic pumping for the surrounding farms and acreage. Predictable schedule, transparent pricing, no game-day surprises.",
    keyword: "septic pumping Pullman WA",
  },
  "colfax-wa": {
    slug: "colfax-wa",
    city: "Colfax",
    state: "WA",
    display: "Colfax, WA",
    distance: "1 hr S of Spokane",
    driveTime: "55–70 minutes",
    neighborhoods: ["Downtown Colfax", "Steptoe", "Endicott", "St. John"],
    intro:
      "Colfax and the surrounding Palouse farming communities are almost entirely on septic — wheat farms, ranches, and small-town homes. We pair Colfax appointments with our Pullman runs so you're getting a real-Spokane operator on a real schedule, not a one-truck local that shows up whenever.",
    keyword: "septic pumping Colfax WA",
  },
  "moses-lake-wa": {
    slug: "moses-lake-wa",
    city: "Moses Lake",
    state: "WA",
    display: "Moses Lake, WA",
    distance: "1 hr 45 min W of Spokane",
    driveTime: "1h 40m – 2h",
    neighborhoods: ["Cascade Valley", "Larson", "Mae Valley", "Moses Lake shoreline"],
    intro:
      "Moses Lake sits at the outer edge of our 2-hour service radius — but the demand there is real. Industrial facilities, hotels, restaurants along I-90, and rural residential properties all need reliable pumping. We batch Moses Lake jobs on scheduled westbound runs so the trip is efficient and the price stays fair.",
    keyword: "septic pumping Moses Lake WA",
  },
};

export const AREA_LIST = Object.values(AREAS);
